import { OrderApiClient } from '@fourthwall/services/dist/OrderApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useGetRefundEstimatedCostsQuery = createQueryHook(
  OrderApiClient.getRefundEstimatedCosts,
  {
    queryKey: ['getRefundEstimatedCosts'],
  },
)
